// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".payment-order-item{cursor:grab;border-radius:8px;padding:10px 15px;text-align:center;width:250px;background:#fff;box-shadow:0px 10px 15px -3px rgba(0,0,0,.1)}", ""]);
// Exports
module.exports = exports;
